/* The Swatch button on the product page, plus the pack flyout.

   Writes to the same localStorage key the swatch pack builder reads, in the
   same shape, so a swatch added here is already in the pack when the builder
   loads. One source of truth, no second store to keep in sync.

   The mat's Add to Cart, sticky bar and express pay are NEVER touched.

   The Swatch button is a slim full-width outline button reading
   "Add to Swatch Pack" / "Added to Swatch Pack", connected flush to the top
   of the No-Sweat Guarantee strip (place() zeroes the strip's top margin so
   the pair reads as one unit).

   The pack lives in a flyout fixed to the left center of the screen.
   Collapsed: a sideways YOUR SWATCHES label beside the stacked circles and a
   bold expand arrow. Expanded: the circles with names and an x, a dashed +
   linking to /products/swatch-pack, and the green checkout button. The
   element is moved to document.body so position:fixed cannot be broken by a
   transformed ancestor. */
(function(){
  var box = document.querySelector("[data-smps]");
  if(!box) return;

  var STORE = "sm_swatchpack_v1", KEEP = 30, MAX = 3;
  var MAP = window.SMPS_MAP || {};
  var root = box.getAttribute("data-root") || "";
  var name = box.getAttribute("data-name") || "this style";
  var PACK_VARIANT = box.getAttribute("data-variant") || "";
  if(!root) return;

  var pill  = box.querySelector("[data-smps-add]");
  var label = box.querySelector(".smps-label");
  var tray  = box.querySelector("[data-smps-tray]");
  var open  = false;

  /* The flyout floats; a transformed ancestor would pin it to the page. */
  tray.classList.add("smps-fly");
  document.body.appendChild(tray);

  function read(){
    try{
      var raw = localStorage.getItem(STORE);
      if(!raw) return [];
      var d = JSON.parse(raw);
      if(!d || !d.skus || !d.at) return [];
      if(Date.now() - d.at > KEEP * 864e5){ localStorage.removeItem(STORE); return []; }
      return d.skus.slice(0, MAX);
    }catch(e){ return []; }
  }
  function write(list){
    try{ localStorage.setItem(STORE, JSON.stringify({at: Date.now(), skus: list})); }catch(e){}
  }
  function nameOf(s){ return (MAP[s] && MAP[s].n) || s; }
  function imgOf(s){ return (MAP[s] && MAP[s].img) || ""; }

  /* The button sits directly above the No-Sweat Guarantee strip, full width,
     flush against it. Fallback when a template has no strip: directly after
     the Size row. The theme re-renders parts of the page on variant change,
     so placement is re-checked for the life of the page. */
  function anchor(){
    var strip = document.querySelector(".sm-nsg-strip");
    if(strip && strip.parentNode) return {parent: strip.parentNode, before: strip, strip: strip};
    var info = document.querySelector(".product__info-container") || document;
    var row = info.querySelector(".sm-size-links") ||
              info.querySelector("variant-selects fieldset, variant-radios fieldset");
    if(row && row.parentNode) return {parent: row.parentNode, before: row.nextSibling, strip: null};
    return null;
  }
  function place(){
    var a = anchor();
    if(!a) return;
    if(a.strip) a.strip.style.marginTop = "0px";
    if(box.isConnected && box.nextSibling === a.before && box.parentNode === a.parent) return;
    a.parent.insertBefore(box, a.before);
    box.dataset.smpsPlaced = "1";
  }

  function el(t,c,x){ var e=document.createElement(t); if(c)e.className=c; if(x)e.textContent=x; return e; }

  function drawFly(list){
    tray.innerHTML = "";
    if(!list.length){ tray.hidden = true; return; }
    var held = list.indexOf(root) > -1;
    tray.classList.toggle("is-open", open);

    if(!open){
      var card = el("button","smps-fly-card");
      card.type = "button";
      card.setAttribute("aria-label","Open your swatches");
      card.appendChild(el("span","smps-fly-side","Your Swatches"));
      var colm = el("span","smps-fly-dots");
      for(var i = 0; i < MAX; i++){
        if(list[i]){
          var im = document.createElement("img");
          im.className = "smps-fly-dot";
          im.src = imgOf(list[i]); im.alt = nameOf(list[i]);
          colm.appendChild(im);
        } else {
          colm.appendChild(el("span","smps-fly-dot smps-fly-dot--empty","+"));
        }
      }
      colm.appendChild(el("span","smps-fly-arrow","❯"));
      card.appendChild(colm);
      card.onclick = function(){ open = true; draw(); };
      tray.appendChild(card);
    } else {
      var panel = el("div","smps-fly-panel");
      var bar = el("div","smps-fly-bar");
      bar.appendChild(el("p","smps-fly-head","Your Swatches"));
      var shut = el("button","smps-fly-shut","❮");
      shut.type = "button";
      shut.setAttribute("aria-label","Minimize your swatches");
      shut.onclick = function(){ open = false; draw(); };
      bar.appendChild(shut);
      panel.appendChild(bar);

      var col = el("div","smps-fly-col");
      for(var i = 0; i < MAX; i++){
        (function(i){
          var s = list[i];
          var cell = el("span","smps-sw-cell");
          if(s){
            var b = el("button","smps-sw");
            b.type = "button";
            var canSwap = !held && s !== root;
            b.setAttribute("aria-label", canSwap
              ? "Replace " + nameOf(s) + " with " + name
              : nameOf(s) + " is in your swatch pack");
            b.title = canSwap ? "Tap to swap for " + name : nameOf(s);
            var src = imgOf(s);
            if(src){
              var im = document.createElement("img");
              im.src = src; im.alt = ""; im.loading = "lazy";
              b.appendChild(im);
            }
            b.appendChild(el("span","smps-sw-n", nameOf(s)));
            if(canSwap){
              b.onclick = function(){
                var cur = read();
                cur[i] = root;
                write(cur);
                draw();
              };
            }
            cell.appendChild(b);
            var rm = el("button","smps-sw-x","×");
            rm.type = "button";
            rm.setAttribute("aria-label","Remove " + nameOf(s) + " from your swatch pack");
            rm.onclick = function(e){
              e.stopPropagation();
              var cur = read();
              var at = cur.indexOf(s);
              if(at > -1){ cur.splice(at, 1); write(cur); draw(); }
            };
            cell.appendChild(rm);
          } else {
            var a = document.createElement("a");
            a.className = "smps-sw smps-sw--empty";
            a.href = "/products/swatch-pack";
            a.setAttribute("aria-label","Add a swatch");
            a.appendChild(el("span","smps-plus","+"));
            a.appendChild(el("span","smps-sw-n","Add"));
            cell.appendChild(a);
          }
          col.appendChild(cell);
        })(i);
      }
      panel.appendChild(col);

      if(PACK_VARIANT){
        var buy = el("button","smps-checkout");
        buy.type = "button";
        buy.textContent = "Check out · $15";
        buy.onclick = function(){ checkout(buy); };
        panel.appendChild(buy);
      }
      tray.appendChild(panel);
    }
    tray.hidden = false;
  }

  /* Same cart line the builder writes. */
  function properties(list){
    var p = {};
    list.forEach(function(s,i){ p["Swatch " + (i+1)] = nameOf(s) + " (" + s + ")"; });
    p["_swatch_skus"] = list.join(",");
    return p;
  }
  function checkout(btn){
    var list = read();
    if(!list.length || !PACK_VARIANT) return;
    btn.disabled = true;
    btn.textContent = "One moment…";
    fetch("/cart.js", {headers:{"Accept":"application/json"}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var line = 0;
        cart.items.forEach(function(it, i){ if(String(it.variant_id) === String(PACK_VARIANT)) line = i + 1; });
        if(line){
          return fetch("/cart/change.js", {
            method:"POST", headers:{"Content-Type":"application/json"},
            body: JSON.stringify({line: line, quantity: 1, properties: properties(list)})
          });
        }
        return fetch("/cart/add.js", {
          method:"POST", headers:{"Content-Type":"application/json"},
          body: JSON.stringify({items:[{id: PACK_VARIANT, quantity: 1, properties: properties(list)}]})
        });
      })
      .then(function(){ window.location.href = "/checkout"; })
      .catch(function(){
        btn.disabled = false;
        btn.textContent = "Check out · $15";
      });
  }

  function draw(){
    var list = read();
    var held = list.indexOf(root) > -1;
    pill.classList.toggle("is-added", held);
    box.classList.toggle("is-added", held);
    label.textContent = held ? "Added to Swatch Pack" : "Add to Swatch Pack";
    pill.setAttribute("aria-label", held
      ? "Remove the " + name + " swatch from your swatch pack"
      : "Add a " + name + " swatch to your swatch pack");
    pill.title = held ? "Remove " + name : "";
    drawFly(list);
  }

  pill.addEventListener("click", function(e){
    e.preventDefault();
    var list = read();
    var at = list.indexOf(root);
    if(at > -1){
      list.splice(at, 1);
      write(list);
      draw();
      return;
    }
    if(list.length >= MAX){
      open = true; /* full: open the flyout so a circle can be swapped */
      draw();
      return;
    }
    list.push(root);
    write(list);
    draw();
  });

  window.addEventListener("storage", function(e){ if(e.key === STORE) draw(); });

  place();
  draw();
  /* Keeper: if a section re-render removed the button, put it back. */
  setInterval(function(){
    if(!box.isConnected || !pill.isConnected){ place(); draw(); }
  }, 600);
})();
